import React, { Component } from 'react';
import canWithdraw from "./Image/canWithdraw.png";
import hadWithdraw from "./Image/hadWithdraw.png";
import Immediately from "./Immediately";
import WithdrawTable from "./withdrawTable";
import { getWithdrawOverview, getWithdrawList } from '@/api/wallet';
import { getQueryString } from '@/utils/tools';

const clsPrefix = 'withdraw';

class Withdraw extends Component {
    constructor(props) {
        super(props);
        this.state = {
            amtAlready: 0,
            amtWithdraw: 0,
            amtOnWay: 0,
            list: [],
            total: 0
        };
    }

    componentDidMount() {
        const biztype = getQueryString('biztype');
        getWithdrawOverview(biztype).then(data => {
            this.setState(data);
        });
        getWithdrawList().then(data => {
            this.setState({ 
                list: data.withdrawOrders,
                total: data.total
            });
        });
    }

    handleChange = (pagination) => {
        const { current } = pagination;
        const offset = (current - 1) * 10;
        getWithdrawList(offset).then(data => {
            this.setState({ 
                list: data.withdrawOrders,
                total: data.total
            });
        });
    }

    render(){
        const { amtAlready, amtWithdraw, list, total } = this.state;
        return(
            <div className={clsPrefix}>
                <div className={`${clsPrefix}-userMessage`}>
                    <div className={`${clsPrefix}-hadWithdraw`}>
                        <img src={hadWithdraw} alt="hadWithdraw"/>
                        <span className={`${clsPrefix}-withdrawMoney`}>已提现
                            <span className={`${clsPrefix}-moneyValue ${clsPrefix}-hadmoneyValue `}>{amtAlready}</span>元
                        </span>
                    </div>
                    <div className={`${clsPrefix}-canWithdraw`}>
                        <img src={canWithdraw} alt="canWithdraw"/>
                        <span className={`${clsPrefix}-withdrawMoney`}>可提现
                            <span className={`${clsPrefix}-moneyValue ${clsPrefix}-canmoneyValue`}>{amtWithdraw}</span>元
                        </span>
                    </div>
                    <Immediately onTabChange={this.props.onTabChange} />
                </div>
                <WithdrawTable
                    withdrawList={list}
                    total={total}
                    onChange={this.handleChange}
                />
            </div>         
        );
    }
}
export default Withdraw;